import { Box, Flex, Text } from '@bonusly/design-system';
import { useCurrentUser, useSpoofing } from '@bonusly/who-am-i';

import { useToggleSuperAdmin } from '../../hooks';
import ToggleOff from './assets/toggle-off.svg?react';
import ToggleOn from './assets/toggle-on.svg?react';

export function ToggleSuperAdminControls() {
	const user = useCurrentUser();
	const { isSpoofing, isLoading } = useSpoofing();

	const handleToggleSuperAdmin = useToggleSuperAdmin(() => {
		window.location.reload();
	});

	const shouldRender = user.super_admin || isSpoofing;
	if (isLoading || !shouldRender) {
		return null;
	}

	return (
		<Flex alignItems="center" bgColor="bg.canvas" borderRadius="sm" data-testid="super-admin-features-toggle" gap={2} mt={2} p={2}>
			<Text fontSize="xs" fontWeight="medium" color="text.soft">
				Turn on/off permissions
			</Text>
			<Box onClick={handleToggleSuperAdmin} cursor="pointer">
				{user.show_superadmin_feature ? <ToggleOn /> : <ToggleOff />}
			</Box>
		</Flex>
	);
}
